import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { Cache } from 'aws-amplify';
import * as i0 from "@angular/core";
var STORAGE_KEY = 'view_as_scope';
var ViewAsScopeService = /** @class */ (function () {
    function ViewAsScopeService() {
        this.scopeSubject = new BehaviorSubject(this.getScope());
        this.scope$ = this.scopeSubject.asObservable();
        // Capture original Cache.getItem before any patches run
        this.originalCacheGetItem = Cache.getItem.bind(Cache);
    }
    /**
     * Check if View As scope is enabled and has valid configuration
     */
    ViewAsScopeService.prototype.isEnabled = function () {
        var scope = this.getScope();
        return scope !== null && scope.enabled && !!scope.role;
    };
    /**
     * Check if the current user can enable View As (super admins only)
     */
    ViewAsScopeService.prototype.canEnable = function () {
        var userAttr = this.getOriginalUserAttributes();
        return userAttr && userAttr['custom:role'] === 'sadmin';
    };
    /**
     * Get the stored View As scope from localStorage
     */
    ViewAsScopeService.prototype.getScope = function () {
        try {
            var stored = localStorage.getItem(STORAGE_KEY);
            if (!stored) {
                return null;
            }
            var parsed = JSON.parse(stored);
            if (!parsed || typeof parsed.enabled !== 'boolean') {
                return null;
            }
            return parsed;
        }
        catch (_a) {
            return null;
        }
    };
    /**
     * Set View As scope. Only allows when canEnable() is true.
     */
    ViewAsScopeService.prototype.setScope = function (scope) {
        if (!this.canEnable()) {
            return;
        }
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(scope));
            this.scopeSubject.next(scope);
        }
        catch (_a) {
            // Silently fail if localStorage is unavailable
        }
    };
    /**
     * Clear View As scope
     */
    ViewAsScopeService.prototype.clearScope = function () {
        try {
            localStorage.removeItem(STORAGE_KEY);
            this.scopeSubject.next(null);
        }
        catch (_a) {
            // Silently fail
        }
    };
    /**
     * Get effective user attributes with View As scope overrides applied.
     * Merges real userAttr with scope overrides for role and entity IDs.
     */
    ViewAsScopeService.prototype.getEffectiveUserAttributes = function () {
        var userAttr = this.getOriginalUserAttributes();
        if (!userAttr) {
            return {};
        }
        var scope = this.getScope();
        if (!scope || !scope.enabled || !scope.role) {
            return tslib_1.__assign({}, userAttr);
        }
        var overridden = tslib_1.__assign({}, userAttr);
        overridden['custom:role'] = scope.role;
        overridden['custom:disti_id'] =
            scope.distiId !== null && scope.distiId !== undefined ? String(scope.distiId) : '';
        overridden['custom:client_id'] =
            scope.clientId !== null && scope.clientId !== undefined ? String(scope.clientId) : '';
        overridden['custom:campus_id'] =
            scope.campusId !== null && scope.campusId !== undefined ? String(scope.campusId) : '';
        return overridden;
    };
    /**
     * Get tooltip text for View As scope (e.g. "Viewing as Client Admin – Acme Corp")
     * Uses stored names when available, falls back to IDs.
     */
    ViewAsScopeService.prototype.getViewAsTooltipText = function () {
        var scope = this.getScope();
        if (!scope || !scope.enabled || !scope.role) {
            return '';
        }
        var roleLabels = {
            distiadmin: 'Partner Admin',
            clientadmin: 'Client Admin',
            campusadmin: 'Campus Admin'
        };
        var roleLabel = roleLabels[scope.role] || scope.role;
        var parts = [roleLabel];
        if (scope.distiId) {
            parts.push(scope.distiName ? "Partner: " + scope.distiName : "Partner: " + scope.distiId);
        }
        if (scope.clientId) {
            parts.push(scope.clientName ? "Client: " + scope.clientName : "Client: " + scope.clientId);
        }
        if (scope.campusId) {
            parts.push(scope.campusName ? "Campus: " + scope.campusName : "Campus: " + scope.campusId);
        }
        return "Viewing as " + parts.join(' – ');
    };
    /**
     * Get original user attributes without any overrides.
     * Use this when you need the real user data (e.g. to show View As controls only to super admins).
     */
    ViewAsScopeService.prototype.getOriginalUserAttributes = function () {
        var value = this.originalCacheGetItem('userAttr');
        return value && typeof value === 'object' ? value : null;
    };
    ViewAsScopeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ViewAsScopeService_Factory() { return new ViewAsScopeService(); }, token: ViewAsScopeService, providedIn: "root" });
    return ViewAsScopeService;
}());
export { ViewAsScopeService };
